export const GET_USER_DETAILS_DATA="GET_USER_DETAILS_DATA";
export const GET_STORETOKEN="GET_STORETOKEN";
